import { AddCartaddEvent, AddCustomEvent, AddLikeEvent, AddOrderEvent, AddPageViewEvent, AddProductDetailViewEvent, AddRateEvent, BluxClient } from '@blux.ai/web-sdk'

let bluxClient
let age = ''
let gender = ''

export default (context, inject) => {
  if (!process.client) {
    return
  }

  bluxInitialization()

  // SNS 로그인 이후 전역 미들웨어에서 이미 세팅되어 오는 케이스가 있어, 초기화 직후 signIn 호출
  const { mbMngNo, ageGroup, sexdSe } = context.store.state.session?.member
  if (mbMngNo) {
    age = ageGroup
    gender = sexdSe

    bluxSignIn(mbMngNo)
  }

  context.store.watch(
    state => state.session.member.mbMngNo,
    (newVal, oldVal) => {
      if (newVal) {
        const { ageGroup, sexdSe } = context.store.state.session.member
        console.log('[blux] 신규 세션 감지', newVal)
        age = ageGroup
        gender = sexdSe

        bluxSignIn(newVal)
      } else {
        console.log('[blux] 토큰 만료 감지')
        age = ''
        gender = ''

        bluxSignOut()
      }
    }
  )

  inject('blux', {
    get client () {
      return bluxClient
    },
    signIn: id => bluxSignIn(id),
    signOut: () => bluxSignOut(),
    setUserProperties: consents => bluxSetUserProperties(consents),
    basicEventSend: (type, item) => bluxBasicEventSend(type, item, age, gender),
    customEventSend: (type, item) => bluxCustomEventSend(type, item),
  })
}

export function bluxInitialization () {
  if (!process.client) {
    return
  }

  let BLUX_APPLICATION_ID = ''
  let BLUX_API_KEY = ''

  if (process.env.VUE_APP_ENV === 'prd' || process.env.VUE_APP_ENV === 'qa') {
    BLUX_APPLICATION_ID = process.env.PRD_BLUX_APPLICATION_ID
    BLUX_API_KEY = process.env.PRD_BLUX_API_KEY
  } else {
    BLUX_APPLICATION_ID = process.env.STG_BLUX_APPLICATION_ID
    BLUX_API_KEY = process.env.STG_BLUX_API_KEY
  }

  const options = {
    bluxApplicationId: BLUX_APPLICATION_ID,
    bluxAPIKey: BLUX_API_KEY,
  }

  console.log('[blux] useragent 확인', window.navigator.userAgent)
  console.log('[blux] 초기화 옵션', options)

  bluxClient = new BluxClient(options)
}

function bluxSignIn (id) {
  console.log('[blux] bluxSignIn 호출', id)
  if (bluxClient) {
    bluxClient.signIn({ userId: id })
    console.log('[blux] 회원 로그인 전송', id)
  }
}

function bluxSignOut () {
  if (bluxClient) {
    bluxClient.signOut()
  } else {
    bluxInitialization()
  }
}

function bluxSetUserProperties ({ phone, pushYn, emailYn, smsYn }) {
  if (bluxClient) {
    const userProperties = {
      marketing_notification_consent: true
    }

    if (phone) {
      userProperties.phone_number = phone
    }

    if (pushYn) {
      userProperties.marketing_notification_push_consent = pushYn === 'Y'
    }

    if (emailYn) {
      userProperties.marketing_notification_email_consent = emailYn === 'Y'
    }

    if (smsYn) {
      userProperties.marketing_notification_sms_consent = smsYn === 'Y'
    }

    console.log('[blux] 프로퍼티 변경 전송', userProperties)

    bluxClient.setUserProperties({
      userProperties
    })
  }
}

function bluxBasicEventSend (type, item, age, gender) {
  let sendData

  if (!item) {
    return
  }

  try {
    if (bluxClient) {
      switch (type) {
        case 'view': // 상품 상세 진입 시 상품 정보 전달
          sendData = new AddProductDetailViewEvent({
            itemId: item.pdNo ?? '',
            customEventProperties: {
              item_code: item.pdNo ?? '',
              item_name: item.exhPdNm ?? '',
              item_category_1_id: item.lctgrNo ?? '',
              item_category_1_name: item.lctgrNm ?? '',
              item_category_2_id: item.mctgrNo ?? '',
              item_category_2_name: item.mctgrNm ?? '',
              item_category_3_id: item.sctgrNo ?? '',
              item_category_3_name: item.sctgrNm ?? '',
              item_brand_name: item.brndNm ?? '',
              item_price: item.price ?? '',
              age,
              gender
            },
          })

          break
        case 'addCart': // 장바구니 담았을 경우 정보 전달, 단건 / 다건 분리
          if (item.length > 0) {
            const data = []

            item.forEach((val) => {
              const temp = new AddCartaddEvent({
                itemId: val.pdNo ?? '',
                customEventProperties: {
                  item_code: val.pdNo ?? '',
                  item_name: val.exhPdNm ?? '',
                  item_category_1_id: val.lctgrNo ?? '',
                  item_category_1_name: val.lctgrNm ?? '',
                  item_category_2_id: val.mctgrNo ?? '',
                  item_category_2_name: val.mctgrNm ?? '',
                  item_category_3_id: val.sctgrNo ?? '',
                  item_category_3_name: val.sctgrNm ?? '',
                  item_price: val.price ?? '',
                  item_quantity: val.spbkQy ?? '',
                  item_dlv_ty: val.dlvTy ? val.dlvTy : val.spbkSeCd ? val.spbkSeCd : '',
                  item_variant: val.variant ?? '',
                  age,
                  gender
                }
              })

              data.push(temp)
            })

            sendData = data
          } else {
            sendData = new AddCartaddEvent({
              itemId: item.pdNo,
              customEventProperties: {
                item_code: item.pdNo ?? '',
                item_name: item.exhPdNm ?? '',
                item_category_1_id: item.lctgrNo ?? '',
                item_category_1_name: item.lctgrNm ?? '',
                item_category_2_id: item.mctgrNo ?? '',
                item_category_2_name: item.mctgrNm ?? '',
                item_category_3_id: item.sctgrNo ?? '',
                item_category_3_name: item.sctgrNm ?? '',
                item_price: item.price ?? '',
                item_quantity: item.spbkQy ? item.spbkQy : item.offlSpbkQy ? item.offlSpbkQy : '',
                item_dlv_ty: item.dlvTy ? item.dlvTy : item.spbkSeCd ? item.spbkSeCd : item.offlSpbkSeCd ? item.offlSpbkSeCd : '',
                age,
                gender
              }
            })
          }

          break
        case 'purchase': // 상품 구매 시 정보 전달
          sendData = new AddOrderEvent({
            items: item.items ?? [],
            orderId: item.orNo ?? '',
            paidAmount: item.paidAmount ?? 0,
            orderAmount: item.orderAmount ?? 0,
            customEventProperties: {
              age,
              gender
            }
          })

          break
        case 'wishlist': // 찜 등록 시 정보 전달
          sendData = new AddLikeEvent({
            itemId: item.pdNo ?? '',
            customEventProperties: {
              age,
              gender
            }
          })

          break
        case 'rating': // 별점 입력 시 정보 전달
          sendData = new AddRateEvent({
            itemId: item.pdNo ?? '',
            rating: item.revwStsc ?? '',
          })

          break
        case 'pageView': // 페이지 방문 시 정보 전달
          sendData = new AddPageViewEvent({
            page: item.page ?? ''
          })

          break
        default:
          break
      }

      if (sendData) {
        bluxClient.sendEvent(sendData)
      } else {
        console.log('[blux] bluxBasicEventSend Error ', type)
      }
    }
  } catch (e) {
    console.log(e)
  }
}

function bluxCustomEventSend (type, item) {
  let sendData

  if (!item) {
    return
  }

  try {
    if (bluxClient) {
      switch (type) {
        case 'search' : // 검색
          sendData = new AddCustomEvent({
            eventType: 'RECENT_SEARCH',
            customEventProperties: {
              item_keyword: item ?? ''
            }
          })

          break
        case 'viewEvent' : // 이벤트 클릭 시
          sendData = new AddCustomEvent({
            eventType: 'EVENT_DETAIL_VIEW',
            customEventProperties: {
              item_evt_nm: item.evtNm ?? '',
              item_evt_no: item.evtNo ?? ''
            }
          })

          break
        case 'viewExbt' : // 기획전 조회
          sendData = new AddCustomEvent({
            eventType: 'EXH_DETAIL_VIEW',
            customEventProperties: {
              item_exbt_no: item.exbtNo ?? ''
            }
          })

          break
        case 'order' : // 주문하기 버튼 클릭 시 (주문 결제 페이지 진입 전)
          if (item.length > 0) {
            const data = []

            item.forEach((val) => {
              const temp = new AddCustomEvent({
                eventType: 'ORDER_BUTTON',
                customEventProperties: {
                  item_code: val.pdNo ?? '',
                  item_name: val.exhPdNm ?? '',
                  item_click_dtm: val.clickDtm ?? '',
                  item_dlv_ty: val.dlvTy ? val.dlvTy : val.spbkSeCd ? val.spbkSeCd : ''
                }
              })

              data.push(temp)
            })

            sendData = data
          }
          break
        case 'topButton' : // [홈메인 > 상단] 쇼핑, 매장 칩 버튼 클릭 시
          sendData = new AddCustomEvent({
            eventType: 'TOP_BUTTON',
            customEventProperties: {
              item_tab_nm: item.tabNm ?? ''
            }
          })

          break
        case 'cartGubun' : // 장바구니 배송 타입 변경 시(택배, 매장픽업 등)
          sendData = new AddCustomEvent({
            eventType: 'CART_GUBUN',
            customEventProperties: {
              item_dlv_ty: item.dlvTy ?? ''
            }
          })

          break
        case 'signUp' : // 회원가입 완료 시
          sendData = new AddCustomEvent({
            eventType: 'SIGN_UP'
          })

          break
        case 'exhBenefitButton' : // 기획전혜택버튼 클릭 시
          sendData = new AddCustomEvent({
            eventType: 'EXH_BENEFIT_BUTTON',
            eventProperties: {},
            customEventProperties: {
              item_exbt_no: item.exbtNo ?? '', // 기획전 번호
              item_join_result: item.result ?? '' // success(참여 완료) / already_joined(이미 참여) / not_eligible(대상 아님) / login_required(비로그인) / fail(오류)
            }
          })

          break
        default:
          break
      }

      if (sendData) {
        bluxClient.sendEvent(sendData)
      } else {
        console.log('[blux] bluxCustomEventSend Error ', type)
      }
    }
  } catch (e) {
    console.log(e)
  }
}
